import { render, staticRenderFns } from "./RedirectUrl.vue?vue&type=template&id=0c08d4f8&scoped=true&"
import script from "./RedirectUrl.vue?vue&type=script&lang=js&"
export * from "./RedirectUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08d4f8",
  null
  
)

export default component.exports